module.exports = __webpack_public_path__ + "img/angststoerungen_3000.2be3974d.png";